module.exports = __webpack_public_path__ + "static/img12-140b6d7a6bf12eafa5ae0c533e68a928.jpg";